import { getRequest } from '../services/requestHandler';
import { GolfBag } from '../models';

export const getGolfBags = async () => {
  const url = 'golfBag/getGolfBags?activeOnly=true&useCache=true';
  const response = await getRequest<GolfBag>('GetGolfBags', url);
  return response;
};
